<template>
<v-container>
    <v-data-table
        :items="services"
        :headers="headers"
        hide-default-footer
        disable-sort
        dense
        show-expand
        
    >
    <template v-slot:expanded-item="{ headers, item }">
    <td :colspan="headers.length" class="pa-0">
    <v-sheet
    color="#F6FEE3"
    elevation="1"
    class="pa-2"
    >
        <v-btn small class="mr-3">
            <v-edit-dialog @save="addOwner(item, item.tmp)">
                <v-icon>mdi-plus</v-icon>
                <template v-slot:input>
                    <v-combobox
                        v-if="users.length > 0"
                        :items="users"
                        item-text="name"
                        @change="item.tmp = $event.name"
                    >
                    </v-combobox>
                </template>
            </v-edit-dialog>
        </v-btn>
        <v-chip close color="green" @click:close="delOwner(item, user)" class="cc" v-for="user in item.service_owners" :key="user.id">{{user.name}}</v-chip>
    </v-sheet>
    </td>
    </template>
    <template v-slot:item.action="{item}">
        <v-btn small @click="delete_service(item)">
            <v-icon>mdi-delete</v-icon>
        </v-btn>
    </template>
    <template v-slot:top>
        <v-row style="width: 100%">
        <v-col align="right">
            <v-btn @click="show">
                Add Service
            </v-btn>
            <v-dialog
                v-model="dialog"
                max-width="500"
            >
            <v-card>
                <v-card-title>
                    Add Service
                </v-card-title>
                <v-card-text>
                    <v-row class="ma-1">
                        <v-col cols="12" class="pb-0 mb-0">
                            <v-text-field
                                label="Service Name"
                                type="text"
                                v-model="service_name"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0">
                            <v-text-field
                                label="Carrier"
                                type="text"
                                v-model="carrier"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0">
                            <v-text-field
                                label="Date"
                                type="number"
                                v-model="provide_date"
                                class="nn"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col align="right">
                        <v-btn color="primary" @click="confirm">
                            Add
                        </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            </v-dialog>

        </v-col>
        </v-row>
    </template>

    </v-data-table>
</v-container>
    
</template>

<script>
import gql from 'graphql-tag'
import Swal from 'sweetalert2'
export default {
    name: 'ServiceManager',
    props: {
        'users': {default: null}
    },
    methods: {
        delete_service(item) {
            Swal.fire({
                text: `Delete service ${item.name} (${item.id})`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$apollo.mutate({
                        mutation: gql`mutation DelService($delServiceId: Int!) {
                            delService(id: $delServiceId)
                        }`,
                        variables: {
                            delServiceId: item.id,
                        }
                    }).then(() => {
                        Swal.fire({
                            text: 'Deleted!',
                            icon: 'success'
                        })
                        this.$apollo.queries.services.refetch()
                    }).catch((e) => {
                        Swal.fire({
                            icon: "error",
                            text: e.message,
                        });
                    })
                }
            })
        },
        delOwner(item, user) {
            Swal.fire({
                text: `Delete user ${user.name} of service ${item.name}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$apollo.mutate({
                        mutation: gql`mutation DelServiceOwner($serviceId: Int!, $name: String!) {
                            delServiceOwner(service_id: $serviceId, name: $name)
                        }`,
                        variables: {
                            serviceId: parseInt(item.id),
                            name: user.name
                        }
                    }).then(() => {
                        Swal.fire({
                            text: 'Deleted!',
                            icon: 'success'
                        })
                        const idx = item.service_owners.indexOf(user)
                        if (idx != -1) item.service_owners.splice(idx, 1)
                        this.$apollo.queries.services.refetch()
                    }).catch((e) => {
                        Swal.fire({
                            icon: "error",
                            text: e.message,
                        });
                    })
                }
            })
        },
        addOwner(item,name) {
            if (name == null) return
            this.$apollo.mutate({
                mutation: gql `
                mutation AddServiceOwner($id: Int!, $name: String!) {
                addServiceOwner(service_id: $id, name: $name) {
                    id
                    name
                }
                }`,
                variables: {
                    id: item.id,
                    name
                }
            }).then((e) => {
                const result = e.data.addServiceOwner
                if (result) {
                    Swal.fire({
                        icon: "success",
                        title: `Sucess to add user ${result.name}`,
                        showConfirmButton: false,
                        toast: true,
                        timer: 1000
                    });
                    item.service_owners.push({name: result.name, id: result.id})
                }
            }).catch((e) => {
                Swal.fire({
                    icon: "error",
                    text: e.message,
                });
            })
        },
        show() {
            this.service_name = null
            this.carrier = null
            this.provide_date = null
            this.dialog = true
        },
        confirm() {
            if (this.service_name == null || this.carrier == null || this.provide_date == null) {
                Swal.fire({
                    icon: "error",
                    title: "Invalid data",
                });
                return;
            }
            this.dialog = false
            this.$apollo.mutate({
                mutation: gql `
                    mutation CreateService($name: String!, $carrier: String!, $date: Int!) {
                        createService(name: $name, carrier: $carrier, date: $date)
                    }`,
                variables: {
                    name: this.service_name,
                    carrier: this.carrier,
                    date: parseInt(this.provide_date)
                }
            }).then((e) => {
                if (e.data.createService) {
                    Swal.fire({
                        icon: "success",
                        title: "Sucess to make service",
                        showConfirmButton: false,
                        toast: true,
                        timer: 1000
                    });
                    this.$apollo.queries.services.refetch()
                }
            }).catch((e) => {
                Swal.fire({
                    icon: "error",
                    text: e.message,
                });
            });
        }
    },
    data: () => {
        return {
            headers: [
                {
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'Service name',
                    value: 'name'
                },
                {
                    text: 'Carrier',
                    value: 'carrier'
                },
                {
                    text: 'Provide days',
                    value: 'provide_date'
                },
                {
                    text: 'action',
                    value: 'action'
                },
                { text: '', value: 'data-table-expand' },

            ],
            dialog: false,
            carrier: null,
            service_name: null,
            provide_date: null,
        }
    },
    apollo: {
        services: {
            query: gql`
                {
                    services {
                        id
                        name
                        carrier
                        provide_date
                        service_owners {
                            id
                            name
                        }
                    }
                }
            `,
            fetchPolicy: "no-cache"
        }
    }
}

</script>

<style scoped>
.nn {
    max-width: 70px;
}
.cc {
    margin-right: 5px;
}
</style>